/*
* README
*
*
* this datepicker in this format
* <div class="custom-date-container">
  *  <div class="date-picker">
        <select class="day">
       ..
        </select>
        <select class="month">
       ..
        </select>
        <select class="year">
        ..
        </select>
    </div>
    <input type="date" class="custom-date"/>
*</div>
* */


"use strict";

var ubian = ubian || {};

ubian.datePicker = {};


ubian.datePicker.init = function () {
    if ($(".date-picker").length == 0) {
        return;
    } else {
        
        $('.custom-date').each(function () {
            if($(this).val() != null || $(this).val() != ""){
                var date = $(this).val().split("-");
                var $datePicker = $(this).parents('.custom-date-container').find('.date-picker');
                $datePicker.find('select.day').val(parseInt(date[2]));
                $datePicker.find('select.month').val(parseInt(date[1]));
                $datePicker.find('select.year').val(date[0]);
            }
        });

        $('select.day, select.year, select.month').each(function(){
           $(this).selectpicker({'size': 5,'noneSelectedText': $(this).data('placeholder')});
           $(this).on("changed.bs.select", function () {
            ubian.datePicker.controlDate($(this).parents(".date-picker"));
        });
        });
    }
};

ubian.datePicker.controlDate = function ($datePicker) {
    var selectedMonth = $datePicker.find('select.month').val();
    var selectedYear = $datePicker.find('select.year').val();
    var $dayPicker = $datePicker.find('select.day');

    if (selectedMonth && selectedYear) {
        ubian.datePicker.controlDayByMonth(selectedMonth, $dayPicker, selectedYear);
    } else if (selectedMonth) {
        ubian.datePicker.controlDayByMonth(selectedMonth, $dayPicker);
    }
}

ubian.datePicker.controlDayByMonth = function (selectedMonth, $dayPicker, selectedYear) {
    selectedYear = selectedYear || 2000;
    var selectedDay = ($dayPicker.val() == "") ? 1 : $dayPicker.val();
    var monthInStringForm = (selectedMonth < 10) ? "0" + selectedMonth : selectedMonth;

    var maxDayInMonth = parseInt(moment(selectedYear + "-" + monthInStringForm + "-01").endOf('month').format('DD'));

    ubian.datePicker.fillDayPickerWithNewDays($dayPicker, maxDayInMonth);
}

ubian.datePicker.fillDayPickerWithNewDays = function ($dayPicker, maxDay) {
    var selectedDay = parseInt($dayPicker.val());
    $dayPicker.empty();
    if (!selectedDay || selectedDay > maxDay) {
        $dayPicker.append('<option value="" disabled selected hidden></option>');
    }
    for (var day = 1; day <= maxDay; day++) {
        if (selectedDay <= maxDay && selectedDay == day) {
            $dayPicker.append('<option value="' + day + '" selected>' + day + '</option>');
        } else {
            $dayPicker.append('<option value="' + day + '">' + day + '</option>');
        }
    }
    $dayPicker.selectpicker('refresh');
    ubian.datePicker.fillDateInput($dayPicker.parents(".date-picker"));
}

ubian.datePicker.fillDateInput = function ($datePicker) {

    var selectedMonth = $datePicker.find('select.month').val();
    var selectedYear = $datePicker.find('select.year').val();
    var selectedDay = $datePicker.find('select.day').val();

    var $dateInput = $datePicker.parents('.custom-date-container').find('.custom-date');

    if (selectedDay != null && selectedMonth != null && selectedYear != null){
        selectedDay = (selectedDay < 10)? "0"+selectedDay : selectedDay;
        selectedMonth = (selectedMonth < 10)? "0"+selectedMonth : selectedMonth;
        $dateInput.val(selectedYear+ "-" + selectedMonth + "-" + selectedDay);
        $dateInput.change();
    } else {
        $dateInput.val("");
    }

}

$(ubian.datePicker.init);